import { render } from "./BreadcrumbsProjectsBlock.vue?vue&type=template&id=f0009c48&ts=true"
import script from "./BreadcrumbsProjectsBlock.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbsProjectsBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__